/* eslint-disable @typescript-eslint/typedef */
import { createSlice } from '@reduxjs/toolkit';

import {
  AddSpinnerPayload,
  AddSystemNoticePayload,
  PrependNotificationsPayload,
  RemoveSpinnerPayload,
  RemoveSystemNoticePayload,
  SetNewNotificationsPayload,
  SetNotificationsPayload,
  SetUserPayload,
  SystemState
} from '../../types/state/system.types';
import { Notice } from '../../types/common.types';

import { generateUUID } from '../../utils/util';

export const initialState: SystemState = {
  notices: [],
  spinners: [],
  user: undefined,
  notifications: [],
  newNotifications: false
};

export const SystemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    addSystemNotice: (state, action: AddSystemNoticePayload): void => {
      const { type, message } = action.payload;

      state.notices.push({ id: generateUUID(), type, message });
    },
    removeSystemNotice: (state, action: RemoveSystemNoticePayload): void => {
      const updatedNotices: Notice[] = state.notices.filter((notice: Notice): boolean => notice.id !== action.payload);
      state.notices = updatedNotices;
    },
    addSpinner: (state, action: AddSpinnerPayload): void => {
      state.spinners.push(action.payload);
    },
    removeSpinner: (state, action: RemoveSpinnerPayload): void => {
      state.spinners = state.spinners.filter((spinner: string): boolean => spinner !== action.payload);
    },
    setUser: (state, action: SetUserPayload): void => {
      state.user = action.payload;
    },
    setNotifications: (state, action: SetNotificationsPayload): void => {
      state.notifications = action.payload;
    },
    prependNotifications: (state, action: PrependNotificationsPayload): void => {
      state.notifications = [...action.payload, ...state.notifications];
    },
    setNewNotifications: (state, action: SetNewNotificationsPayload): void => {
      state.newNotifications = action.payload;
    }
  }
});

export const {
  addSystemNotice,
  removeSystemNotice,
  addSpinner,
  removeSpinner,
  setUser,
  setNotifications,
  prependNotifications,
  setNewNotifications
} = SystemSlice.actions;

export default SystemSlice.reducer;
